import styled from 'styled-components';

export const Wrapper = styled.div<{needWrapGap?: boolean}>`
    margin-top: 20px;
    ${({ needWrapGap }) => needWrapGap ? 'gap: 32px' : ''};
`;

export const Container = styled.div`
    width: 100%;

    & > div:first-of-type {
        padding-left: 0;
        padding-right: 0;
    }
`;
